import { render, staticRenderFns } from "./addScope.vue?vue&type=template&id=d0d430b0&scoped=true"
import script from "./addScope.vue?vue&type=script&lang=js"
export * from "./addScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d430b0",
  null
  
)

export default component.exports